import { createAction } from 'redux-actions';
import { callApi, getEndpoint } from '../../../../utils/api';
import {
  isAppSell,
  isCollegeExchange,
  isExchange,
  isCollegeDistribute,
  isSell,
} from '../../../../utils/transactions-util';

const CONFIRMATION_EMAIL = 'CONFIRMATION_EMAIL';

export default function userCommunication(
  state = {
    confirmation: {
      sendingEmail: false,
      emailSentSuccessfully: false,
      emailFailed: false,
    },
  },
  { type }
) {
  switch (type) {
    case `${CONFIRMATION_EMAIL}_PENDING`:
      return {
        ...state,
        confirmation: {
          ...state.confirmation,
          sendingEmail: true,
        },
      };
    case `${CONFIRMATION_EMAIL}_FULFILLED`:
      return {
        ...state,
        confirmation: {
          ...state.confirmation,
          sendingEmail: false,
          emailSentSuccessfully: true,
        },
      };
    case `${CONFIRMATION_EMAIL}_REJECTED`:
      return {
        ...state,
        confirmation: {
          ...state.confirmation,
          sendingEmail: false,
          emailFailed: true,
        },
      };
    default:
      return state;
  }
}

/**
 *
 * @param transactions Transactions object returned from successful transaction object
 * @returns {function(*)}
 */
export const sendConfirmationEmail = (transactions) => {
  const transactionsWithConfirms = transactions.filter(
    (t) => t.confirmationNumber.length
  );
  const emailBody = {
    lineOfBusiness: {
      enumerationID: 10,
      enumerationName: 'retail',
    },
    processor: {
      enumerationID: 100,
      enumerationName: 'client',
    },
    status: {
      enumerationID: 100,
      enumerationName: 'success',
    },
    webApplication: {
      agent: '007',
      '@Type': 'WebApplication',
    },
    runtimeIdentifier: {
      name: 'AAW-AAR',
      domain: 'RETE',
      hostname: 'self-serve-ui',
    },
    aarTransactions: transactionsWithConfirms,
  };

  if (isExchange() || isCollegeExchange()) {
    emailBody.target = {
      enumerationID: 1002,
      enumerationName: 'exchange',
    };
  } else if (isSell() || isCollegeDistribute() || isAppSell()) {
    emailBody.target = {
      enumerationID: 1003,
      enumerationName: 'redemption',
    };
  }

  return (dispatch) => {
    const action = createAction(CONFIRMATION_EMAIL)(
      callApi(
        getEndpoint('confirmationEmail'),
        { method: 'POST' },
        JSON.stringify(emailBody)
      )
    );
    dispatch(action);
  };
};
